/**
 * Simple cookie helpers (no extra dependency).
 *
 * How cookies help your site:
 * - Consent: Remember if the user accepted cookie policy (GDPR/friendlier UX).
 * - Preferences: Save theme, language, or "remember me" choices.
 * - Analytics: Google Analytics uses cookies for sessions and traffic (you can gate this on consent).
 * - Returning visitors: e.g. "Welcome back" or pre-fill forms.
 *
 * Usage:
 *   import { getCookie, setCookie } from '../utils/cookies'
 *   setCookie('cookie_consent', 'accepted', { days: 365 })
 *   const consent = getCookie('cookie_consent')
 */

const defaultOptions = { days: 365, path: '/' }

export function getCookie(name) {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

export function setCookie(name, value, options = {}) {
  if (typeof document === 'undefined') return
  const { days, path } = { ...defaultOptions, ...options }
  let expires = ''
  if (days) {
    const d = new Date()
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + d.toUTCString()
  }
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=' + (path || '/')
}

export function deleteCookie(name, path = '/') {
  if (typeof document === 'undefined') return
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + path
}
